export const token = 'token';
export const blogItems = 'blogItems';